import TurndownService from "turndown";

import { BW_EMOJI_ALT, BW_EMOJI_DOM_ALT, BW_EMOJI_MARKDOWN } from "./bw-emoji";

export const htmlToMarkdown = (html: string) => {
  const turndownService = new TurndownService({
    emDelimiter: "*",
    strongDelimiter: "**",
  });
  turndownService.addRule("mention", {
    filter: (node: any) =>
      node.nodeName === "SPAN" && node.getAttribute("data-type") === "mention",
    replacement: (content, node) => {
      const element = node as Element;
      const id = element.getAttribute("data-id");
      const label = element.getAttribute("data-label");
      const email = element.getAttribute("data-email");
      return `@[${label}](userId:${id},email:${email})`;
    },
  });
  const isEmojiAlt = (alt: string) =>
    alt === BW_EMOJI_DOM_ALT || alt === BW_EMOJI_ALT;

  turndownService.addRule("customEmoji", {
    // Either marker is enough. Tiptap stamps data-type="emoji" on every image
    // node it renders, but `markdownToHtml` does not — so matching on the alt
    // too keeps the token stable even when this runs on HTML that never passed
    // through the editor.
    filter: (node: any) =>
      node.nodeName === "IMG" &&
      (node.getAttribute("data-type") === "emoji" ||
        isEmojiAlt(node.getAttribute("alt") ?? "")),
    replacement: (_content, node) => {
      const element = node as Element;
      const alt = element.getAttribute("alt") ?? "";
      // `Image.configure` stamps data-type="emoji" on EVERY image node, so an
      // ordinary inline image from an older body reaches this rule too. Only the
      // picker's logo carries this alt — anything else keeps its own markdown.
      if (!isEmojiAlt(alt)) {
        return `![${alt}](${element.getAttribute("src") ?? ""})`;
      }
      // The src is deliberately NOT echoed back. Bodies written before the emoji
      // was shrunk carry a 5,962-char data URI; re-emitting it would exceed the
      // channel's character limit and make the edit un-saveable, so every era
      // normalizes to the current token and heals on first edit.
      return BW_EMOJI_MARKDOWN;
    },
  });
  // turndownService.addRule('underline', {
  //   filter: (node) => node.nodeName === 'U',
  //   replacement: (content) => {
  //     return `==${content}==`;
  //   },
  // });
  // A link whose text IS its address is what `markdownToHtml`'s linkify makes of
  // a bare URL or email. Turndown would write it back as `[url](url)`, and the
  // body is quoted verbatim in emails, pushes and inbox rows
  // (`Message.plainBody`), where that syntax shows raw — so it goes back bare.
  turndownService.addRule("autolink", {
    filter: (node: any) => {
      if (node.nodeName !== "A") return false;
      const href: string = node.getAttribute("href") ?? "";
      const text: string = (node.textContent ?? "").trim();
      return text !== "" && (href === text || href === `mailto:${text}`);
    },
    replacement: (_content, node) =>
      ((node as Element).textContent ?? "").trim(),
  });
  turndownService.addRule("strikethrough", {
    filter: (node: any) => node.nodeName === "S",
    replacement: (content: any) => {
      return `~~${content}~~`;
    },
  });
  return turndownService.turndown(html);
};
